import { PFieldset } from "@porsche-design-system/components-react"
import { useIntl } from "react-intl"
import { FormLayout, FormLayoutGroup } from "src/components/form/formLayout/FormLayout"
import { Skeleton } from "../../../skeleton"
import { inventoryAndIntakeFieldMessages } from "../common"

export const InventoryAndIntakeFormSkeleton = () => {
	const { formatMessage } = useIntl()
	return (
		<FormLayoutGroup>
			<PFieldset label={formatMessage(inventoryAndIntakeFieldMessages.inventoryTitle)}>
				<FormLayout $width="quarter">
					<Skeleton.RadioGroup count={6} withLabel />
					<Skeleton.RadioGroup count={2} withLabel />
					<Skeleton.RadioGroup count={3} withLabel />
				</FormLayout>
			</PFieldset>
			<PFieldset label={formatMessage(inventoryAndIntakeFieldMessages.intakeTitle)}>
				<FormLayout $width="quarter">
					{Array.from({ length: 7 }, (_, i) => (
						<Skeleton.Input key={i} withLabel />
					))}
				</FormLayout>
			</PFieldset>
		</FormLayoutGroup>
	)
}
